// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'picture';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.858 16.313a1.125 1.125 0 0 1-1.125 1.125H2.267a1.125 1.125 0 0 1-1.125-1.125V1.688A1.125 1.125 0 0 1 2.267.563h11.25c.294 0 .575.114.786.319l2.216 2.162a1.124 1.124 0 0 1 .339.806z' />
    <path d='M4.517 5.625a1.687 1.687 0 1 0 3.375 0 1.687 1.687 0 0 0-3.375 0zm9.593 8.025-2.944-4.416a.758.758 0 0 0-1.253-.014l-2.019 2.883-1.25-1.003a.758.758 0 0 0-1.106.172L3.955 13.65' />
  </g>
);

export const viewBox = '0 0 18 18';
